// Sélecteur segmenté d'univers [ Chantier | Interventions ] — demandé par
// l'owner : un bouton en haut, visible dans les deux espaces, qui bascule.
// Rendu seulement si le flag univers est actif ET que le serveur annonce
// l'univers maintenance pour cet utilisateur (owner/manager + module).
import React from "react";
import { useNavigate } from "react-router-dom";
import { HardHat, Wrench } from "lucide-react";
import { useModules } from "../../hooks/useModules";
import { UNIVERSES_ENABLED, rememberUniverse } from "../../lib/universes";

export default function UniverseSwitch({ current }) {
  const navigate = useNavigate();
  const { universes } = useModules();
  if (!UNIVERSES_ENABLED || !universes.maintenance) return null;

  const go = (universe) => {
    if (universe === current) return;
    rememberUniverse(universe);
    navigate(universe === "maintenance" ? "/interventions" : "/dashboard");
  };

  const seg = (universe, label, Icon, testid) => {
    const active = current === universe;
    return (
      <button
        type="button"
        data-testid={testid}
        onClick={() => go(universe)}
        aria-pressed={active}
        /* Mesuré 33 x 32 à 320 px : la hauteur venait d'un `minHeight: 32` en
           style inline, qu'aucune classe responsive ne pouvait corriger. Sur
           mobile le libellé est déjà masqué (`hidden sm:inline`), la cible se
           réduisait donc à l'icône. C'est le basculement Chantier /
           Interventions, la navigation la plus structurante du produit : elle
           passe à 44 x 44 au doigt, et garde sa densité d'origine à partir de
           md. */
        className={`flex items-center justify-center gap-1.5 rounded-md px-2.5 text-xs font-semibold transition-colors min-h-[44px] min-w-[44px] md:min-h-[32px] md:min-w-0 ${
          active
            ? "bg-card text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <Icon size={13} aria-hidden="true" />
        <span className="hidden sm:inline">{label}</span>
      </button>
    );
  };

  return (
    <div
      className="flex items-center gap-0.5 rounded-lg border border-border bg-muted p-0.5 shrink-0"
      role="group"
      aria-label="Changer d'univers"
      data-testid="universe-switch"
    >
      {seg("chantier", "Chantier", HardHat, "universe-seg-chantier")}
      {seg("maintenance", "Interventions", Wrench, "universe-seg-interventions")}
    </div>
  );
}
